const table = {
  columnList: 'Column list',
  noResults: 'No Results Found',
  noResultsSubHeader: 'We can\'t find any item matching your search',
};

export default table;
